import './assets/scss/styles.scss';

import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import { Footer } from "./cmps/footer";
import { Header } from "./cmps/header";
import { HomePage } from './pages/home-page';
import { ContactUs } from './pages/contact-us';
import { Menu } from './pages/menu';
import { About } from './pages/about';
import { ActionsBtn } from './cmps/actions-btn';

export const App = () => {
    return (
        <Router>
            <section className="app main-layout full">
                <Header />
                <Routes>
                    <Route element={<HomePage />} path='/'  />
                    <Route element={<ContactUs />} path='/contact-us'  />
                    <Route element={<Menu />} path='/menu'  />
                    <Route element={<About />} path='/about'  />
                </Routes>
                <Footer />
                <ActionsBtn />
            </section>
        </Router>
    );
};
